import { render, staticRenderFns } from "./MemberActivityReport.vue?vue&type=template&id=2bd1268c&scoped=true&"
import script from "./MemberActivityReport.vue?vue&type=script&lang=js&"
export * from "./MemberActivityReport.vue?vue&type=script&lang=js&"
import style0 from "./MemberActivityReport.vue?vue&type=style&index=0&id=2bd1268c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1268c",
  null
  
)

export default component.exports